export const UpravljanjeKorisnicimaResourcesDE: UpravljanjeKorisnicimaResourcesBSInterface =
  {
    dupplicateError:
      "Hinzufügen fehlgeschlagen, eingegebene Daten sind dupliziert",
    upravljanjeKorisnicima: {
      title: "Benutzerverwaltung",
      dropdownLabel: "Benutzer auswählen:",
      dropdownPlaceholder: "Benutzer aus Liste auswählen",
      dropdownNoOptionsMessage: "Keine Daten",
      addCompanyButton: "Benutzer hinzufügen",
      next: "Auswählen",
      back: "Zurück",
    },
    UKPPK: {
      title: "Benutzerverwaltung Benutzerdatenverifizierung",
      addCompanyButton: "Unternehmen hinzufügen",
      addUserPosition: "Arbeitsplatz hinzufügen",
      addRecord: "Evidenz hinzufügen",
      branch: "Filiale: ",
      address: "Adresse: ",
      position: "Arbeitsplatz: ",
    },
    branchManagement: {
      currentBranches: "Aktuelle Filialen für",
      noBranchesAssigned: "Keine Filialen diesem Benutzer zugewiesen.",
      availableBranches: "Verfügbare Filialen",
      addBranch: "Filiale hinzufügen",
      hide: "Verstecken",
      remove: "Entfernen",
      add: "Hinzufügen",
      noAvailableBranches: "Keine verfügbaren Filialen zum Hinzufügen.",
      loading: "Laden...",
      error: "Fehler:",
    },
    menuAccessRights: {
      title: "Menüzugriffsrechte für",
      saveButton: "Änderungen speichern",
      description:
        "Wählen Sie die Bildschirme aus, die der Benutzer im Menü sehen kann. Sie können Elemente für jede Kategorie hinzufügen oder entfernen.",
      selectPlaceholder: "Bildschirme auswählen...",
      noOptions: "Keine Optionen verfügbar",
      updateError: "Fehler beim Aktualisieren der Zugriffsrechte.",
    },
    managerChief: {
      titleManager: "Manager in Filialen",
      titleChief: "Chef in Unternehmen",
      noManagers: "Der Benutzer ist keiner Filiale als Manager zugewiesen.",
      noChiefs: "Der Benutzer ist keinem Unternehmen als Chef zugewiesen.",
    },
    contractedHours: {
      title: "Vertragsarbeitsstunden",
      label: "Wochenstunden",
      hint: "Standard sind 40 Stunden pro Woche. In der Arbeitszeittabelle wird eine Überschreitung angezeigt, wenn ein Mitarbeiter in einer Kalenderwoche (Mo–So) darüber liegt.",
      save: "Speichern",
      saving: "Speichern...",
      saved: "Vertragsstunden gespeichert.",
      error: "Fehler beim Speichern der Vertragsstunden.",
      invalid: "Geben Sie eine gültige Stundenzahl ein (1–168).",
      noPermission:
        "Nur Manager, Chefs oder Admins können Vertragsstunden ändern.",
    },
  };

export interface UpravljanjeKorisnicimaResourcesBSInterface {
  dupplicateError: string;
  upravljanjeKorisnicima: {
    title: string;
    dropdownLabel: string;
    dropdownPlaceholder: string;
    dropdownNoOptionsMessage: string;
    addCompanyButton: string;
    next: string;
    back: string;
  };
  UKPPK: {
    title: string;
    addCompanyButton: string;
    addUserPosition: string;
    addRecord: string;
    branch: string;
    address: string;
    position: string;
  };
  branchManagement: {
    currentBranches: string;
    noBranchesAssigned: string;
    availableBranches: string;
    addBranch: string;
    hide: string;
    remove: string;
    add: string;
    noAvailableBranches: string;
    loading: string;
    error: string;
  };
  menuAccessRights: {
    title: string;
    saveButton: string;
    description: string;
    selectPlaceholder: string;
    noOptions: string;
    updateError: string;
  };
  managerChief: {
    titleManager: string;
    titleChief: string;
    noManagers: string;
    noChiefs: string;
  };
  contractedHours: {
    title: string;
    label: string;
    hint: string;
    save: string;
    saving: string;
    saved: string;
    error: string;
    invalid: string;
    noPermission: string;
  };
}
